import React, { useEffect, useState } from "react";
import adobe from "../static/adobe.svg";
import get from 'lodash/get';
import delhigovt from "../static/delhigovt.svg";
import testing from "../static/testing.png";
import testing2 from "../static/testing2.png";
import map from "../static/map.png";
import NewWindowLink from "./NewWindowLink";
import OtherLinks from "./OtherLinks";
import Footer from "./Footer";
import axios from 'axios';
import BedVentilatorCard from 'components/BedVentilatorCard';

import CovidTest from "./CovidTest";
// import MapEmbedModal from './MapEmbedModal';
import { EXTERNAL_URLS, MAP_CONSTANTS } from "../constants";
import { result } from "lodash";

function CovidDelInfo() {
  const [showModal, setShowModal] = useState(false);
  const[loading, setLoading] = useState(true);
  const[beds, setBeds] = useState ({});
  const[ventilators, setVentilators] = useState({});
  const[ICUWOVentialtors, setICUWOVentialtors] = useState({});

  React.useEffect(function effectFunction() {
    async function fetchData() {
        fetch("https://covid-dashboard.jantasamvad.org/covid-info.js").then(
          result => result.text()
        ).then(
          text => {
            const jsonString = text.substring(
              text.indexOf('{'),
              text.lastIndexOf('}') + 1
            );
          const data = JSON.parse(jsonString);
          setBeds(data.beds.All);
          setVentilators(data.ventilators.All);
          setICUWOVentialtors(data.icu_beds_without_ventilator.All)
          setLoading(false);
          }
        )
      //substring of js received and semicolon remove
      //var myJason = JSON.stringify(response)
      //  const data = await response.json();
       // updateData(json);
        //  beds= .All;
        //  ventilator= text.All;

       // console.log("data here "+ JSON.stringify(data));
    }
    fetchData();
}, []);

  return (
    <div>
      <main>
        <div className="maintitlebar">
          <h1>
            Information
            About Corona
          </h1>
          <img
            alt="Delhi Govt Logo"
            className="delhi-govt-logo"
            src={delhigovt}
            style={{ height: "70px" }}
          />
        </div>
        <div id="main--sections">
          <div id="symptoms">
            <a
              className="cardgrid"
              target="_blank"
              rel="noopener noreferrer"
              href="https://coronabeds.jantasamvad.org/"
            >
              <div className="bedsVentilatorWrapper">
                <BedVentilatorCard
                  title="COVID-19 Beds across Delhi"
                  total={beds.total}
                  occupied={beds.occupied}
                  vacant={beds.vacant}
                />
                <BedVentilatorCard
                  title="COVID-19 with Ventilators"
                  total={ventilators.total}
                  occupied={ventilators.occupied}
                  vacant={ventilators.vacant}
                />
                <BedVentilatorCard
                  title="COVID-19 ICU without Ventilators"
                  total={ICUWOVentialtors.total}
                  occupied={ICUWOVentialtors.occupied}
                  vacant={ICUWOVentialtors.vacant}
                />
              </div>
            </a>

            <div onClick={() => {
              setShowModal(true);
            }} id="symptomsmain">

              <div id="symptoms--content">
                Find out if you’re infected
                <div
                  id="test--btn"
                >
                  Take the test →
                </div>
              </div>
            </div>
            <div className="infogrid">
              <NewWindowLink className="infogrid--element" url={MAP_CONSTANTS.covidHealthServices}>
                <div
                  className="infogrid--item"
                  style={{ backgroundImage: `url(${testing})` }}>
                  Find COVID Health Services
                </div>
              </NewWindowLink>
              <NewWindowLink  className="infogrid--element" url={EXTERNAL_URLS.governmentOrders}>
                <div
                  className="infogrid--item"
                  style={{ backgroundImage: `url(${testing2})` }}>
                  Government Orders
                </div>
              </NewWindowLink>
              <NewWindowLink className="infogrid--element" url={MAP_CONSTANTS.containmentZones}>
                <div
                  className="infogrid--item"
                  style={{ backgroundImage: `url(${map})`, color: "black" }}>
                  Containment Zones
                </div>
              </NewWindowLink>
            </div>
          </div>
          <div>
            <div className="asideComponent">
              <h6>Downloads</h6>
              <NewWindowLink url={EXTERNAL_URLS.covidHealthServicesPDF}>
                <div className="asideComponentItem">
                  <img src={adobe} style={{ marginRight: "8px" }} />
                  List of COVID Health Services
                </div>
              </NewWindowLink>
              <NewWindowLink url={EXTERNAL_URLS.containmentZonesPDF}>
                <div className="asideComponentItem">
                  <img src={adobe} style={{ marginRight: "8px" }} />
                  List of Containment Zones
                </div>
              </NewWindowLink>
            </div>
            <OtherLinks />
          </div>
       </div>
      </main>
      <CovidTest
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      />
      <Footer />
    </div>
  );
      }


export default CovidDelInfo;
